import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateFeedBacks } from '@store/slice/feedBacksSlice'
import { updateNotification, updateData } from '@store/slice/mainSlice'
import { get } from '@util/xhrAPI'
import { useTranslation } from 'react-i18next'
import useDynamicForm from '@hook/useDynamicForm'
import useDeleteButton from '@hook/useDeleteButton'
import usePathGenerator from '@hook/usePathGenerator'
import { useTheme } from '@table-library/react-table-library/theme'
import { getTheme } from '@table-library/react-table-library/baseline'
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell,
} from "@table-library/react-table-library/table"
import Alert from '@ui/elements/Alert'
import Div from '@ui/layout/Div'
import Buttons from '@ui/elements/Buttons'
import { useNavigate } from 'react-router-dom'

const ListFeedBacks = () => {
  const { feedBacks } = useSelector(state => state.feedBacks)
  const { mission } = useSelector(state => state.main)
  const theme = useTheme(getTheme())
  const dispatch = useDispatch()
  const toggleDynamicForm = useDynamicForm()
  const deleteButton = useDeleteButton()
  const [t] = useTranslation('common')
  const navigate = useNavigate()
  const getDynamicPath = usePathGenerator()

  const dataFeedBacks = { nodes: [] }
  if (feedBacks) {
    dataFeedBacks.nodes = Object.values(feedBacks)
  }

  const goToShowPage = id => navigate(getDynamicPath('sterilizationShow', { id }))

  const removeFeedBack = feedBack => {
    const { id, links } = feedBack
    get(`${import.meta.env.VITE_API_URL}${links.remove}`, response => {
      const { code } = response
      if (code === 200) {
        const feedBack = feedBacks[id]
        const feedBacksList = { ...feedBacks }
        delete feedBacksList[id]
        dispatch(updateFeedBacks({ ...feedBacksList }))
        dispatch(updateNotification({ type: 'is-success', message: t('messages.removed_successfuly', { title: feedBack.id }) }))
      } else {
        dispatch(updateNotification({ type: 'is-danger', message: t('messages.error_occured') }))
      }
    })
  }

  useEffect(() => {
    get(`${import.meta.env.VITE_API_URL}/api/missions/${mission.id}/feed-backs`, response => {
      const { code, options, feedBacks } = response
      if (code === 200) {
        dispatch(updateFeedBacks(feedBacks))
        dispatch(updateData({ feedBacks: options }))
      }
    })
  }, [])

  return (
    <Div cssClass='users-list'>
      <Div cssClass='actions-zone'>
        <Buttons buttons={{
          icon: 'icon-add',
          cssClass: 'is-info is-small',
          callback: () => toggleDynamicForm('feedBack', 'feedBacks'),
          text: t('actions.add')
        }}
        />
      </Div>
      <h2 className='zone-title'>{t('titles.feedBacks_list')}</h2>
      {null !== feedBacks && dataFeedBacks.nodes.length
        ? <>
          <Table data={dataFeedBacks} theme={theme}>
            {(tableList) => (
              <>
                <Header>
                  <HeaderRow>
                    <HeaderCell>ID</HeaderCell>
                    <HeaderCell>{t('table.Note')}</HeaderCell>
                    <HeaderCell>{t('table.Comment')}</HeaderCell>
                    <HeaderCell>{t('table.IsResponseSent')}</HeaderCell>
                    <HeaderCell>Actions</HeaderCell>
                  </HeaderRow>
                </Header>
                <Body>
                  {tableList.map(item =>
                    <Row key={item.id} item={item}>
                      <Cell>{item.id}</Cell>
                      <Cell>{item.note}</Cell>
                      <Cell>{item.comment}</Cell>
                      <Cell>{item.isResponseSent ? t('labels.yes') : t('labels.no')}</Cell>
                      <Cell className='table-actions'>
                        <Buttons buttons={[
                          {
                            icon: 'icon-clipboard',
                            cssClass: 'is-info is-small',
                            callback: () => goToShowPage(item.sterilizationCall)
                          },
                          {
                            icon: 'icon-create',
                            cssClass: 'is-info is-small',
                            callback: () => toggleDynamicForm('feedBack', 'feedBacks', item)
                          }
                        ]} />
                        {deleteButton(item, item.name, removeFeedBack)}
                      </Cell>
                    </Row>
                  )}
                </Body>
              </>
            )}
          </Table>
        </>
        : <Alert type='is-info' message={t('messages.empty_list')} />
      }
    </Div>
  )
}

export default ListFeedBacks